export const baseUrl="https://myserver.zigglu.com"